<template>
  <div class="history-list" data-test="history-export-results">
    <article v-for="(item, itemIndex) in items" :key="item.examination_id" class="history-record" data-test="history-export-result">
      <header class="history-record__header">
        <div><small>{{ $t('license.history_export.date') }}</small><strong>{{ formatDate(item.examination_date) }}</strong></div>
        <div><small>{{ $t('license.history_export.acc_no') }}</small><strong>{{ item.acc_no }}</strong></div>
        <div><small>{{ $t('license.history_export.medical_record') }}</small><strong>{{ item.medical_record }}</strong></div>
        <div><small>{{ $t('license.history_export.patient') }}</small><strong>{{ item.patient_name }}</strong></div>
      </header>
      <ul>
        <li v-for="(artifact, artifactIndex) in item.artifacts" :key="artifact.id">
          <v-checkbox
            class="history-artifact-select"
            :input-value="selected.includes(artifact.id)"
            :aria-label="$t('license.history_export.select_artifact', { accNo: item.acc_no, filename: artifact.filename })"
            hide-details
            data-test="history-artifact-select"
            @change="$emit('toggle', artifact.id)"
          />
          <v-icon small aria-hidden="true">{{ artifact.type === 'pdf' ? 'picture_as_pdf' : 'image' }}</v-icon>
          <span class="history-record__filename">{{ artifact.filename }}</span>
          <span class="history-record__size">{{ formatSize(artifact.size) }}</span>
          <historical-export-download-action
            :artifact="artifact"
            :exam-index="itemIndex + 1"
            :artifact-index="artifactIndex + 1"
            :disabled="offline"
            @download="$emit('download', $event)"
          />
          <span v-if="errors[artifact.id]" class="history-record__error" role="alert">
            {{ $t(`license.history_export.errors.${errors[artifact.id]}`) }}
            <v-btn flat data-test="history-export-artifact-retry" @click="$emit('download', artifact)">{{ $t('license.history_export.retry') }}</v-btn>
          </span>
        </li>
      </ul>
    </article>
  </div>
</template>

<script>
import HistoricalExportDownloadAction from './HistoricalExportDownloadAction.vue'

export default {
  components: { HistoricalExportDownloadAction },
  props: {
    items: { type: Array, required: true },
    selected: { type: Array, required: true },
    errors: { type: Object, default: () => ({}) },
    offline: { type: Boolean, default: false },
  },
  methods: {
    formatDate(value) {
      return new Intl.DateTimeFormat(this.$i18n.locale, {
        timeZone: 'Asia/Bangkok', year: 'numeric', month: '2-digit', day: '2-digit',
      }).format(new Date(value))
    },
    formatSize(size) { return size < 1024 * 1024 ? `${Math.ceil(size / 1024)} KB` : `${(size / 1024 / 1024).toFixed(1)} MB` },
  },
}
</script>

<style lang="scss" scoped>
.history-list { display: grid; gap: 16px; }
.history-record { border: 1px solid var(--evas-border); border-radius: 4px; overflow: hidden; background: var(--evas-surface); color: var(--evas-text); }
.history-record__header { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; padding: 14px 16px; background: var(--evas-surface-2); }
.history-record__header div { display: grid; gap: 2px; }
.history-record__header small { color: var(--evas-text-label); }
.history-record ul { list-style: none; padding: 0; margin: 0; }
.history-record li { display: flex; align-items: center; min-height: 52px; gap: 10px; padding: 4px 12px; border-top: 1px solid var(--evas-border); }
.history-artifact-select { flex: 0 0 44px; min-width: 44px; min-height: 44px; margin: 0; align-items: center; justify-content: center; }
.history-record__filename { flex: 1; overflow-wrap: anywhere; }
.history-record__size { color: var(--evas-text-label); font-variant-numeric: tabular-nums; }
.history-record__error { flex-basis: 100%; margin-left: 42px; color: #b71c1c; }
.history-record__error .v-btn { min-width: 44px; min-height: 44px; }
@media (max-width: 1100px) { .history-record__header { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 600px) {
  .history-record__header { grid-template-columns: 1fr; gap: 8px; }
  .history-record li { flex-wrap: wrap; }
  .history-record__filename { flex-basis: calc(100% - 80px); }
  .history-record__size { margin-left: 52px; }
}
</style>
